import { render } from "./commentInput.vue?vue&type=template&id=1adab27e"
import script from "./commentInput.vue?vue&type=script&lang=js"
export * from "./commentInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__